<div class="container">

    <div class="title-top-container">
        <div class="logistic-portal-container">
            <p-button icon="pi pi-truck" />
            <h3>LOGISTIC <br> PORTAL</h3>
        </div>
        <div class="secure-session-container">
            <p-tag  icon="pi pi-shield" value="SECURE SESSION" [rounded]="true" />
        </div>
    </div>

    <div class="image-container">
        <img src="truck.png">
        <h2>Logistic Portal</h2>
        <p>Driver Access Terminal</p>
    </div>

    <h2 class="welcome-text">Welcome Back, Driver</h2>

    <p-card class="card-message-signed-link">
        <ng-template pTemplate="header">
            <div style="display: flex;justify-content: center;   padding-top: 15px;">
                <img src="key.png" />
            </div>
            
        </ng-template>
        <p class="text-signed-link">
            You are accessing this portal via a
            <span class="link">secure signed link</span>.
            Your session is uniquely encrypted and verified for this device.
        </p>
    </p-card>

    <!--<div class="terms-container">
      <p-checkbox [binary]="true" [(ngModel)]="accepted" (onChange)="termsAcceptedChange()" />
      <label  for="terms">
        I have read and agree to the
        <a href="">Privacy Policy</a> and
        <a href="">Terms of Service</a>
        regarding the handling of my delivery data.
      </label>
    </div>-->

    <div class="buttons-container">
        <p-button (click)="openQRScanner()" label="Scan Document QR Code" icon="pi pi-qrcode" iconPos="left" variant="outlined" />
    </div>


    <tgcs-qr-scanner #qrScanner *ngIf="isCameraOpen" (closeCamera)="isCameraOpen = false" (qrCodeCaptured)="qrCodeCaptured($event) " ></tgcs-qr-scanner>


    <div class="footer-logo">
      <img src="jabil.svg"/>
    </div>


</div>